
export enum EntityActionTypes {
  Add, Edit, Delete, Refresh, None, Clone, RefreshOnDelete
}
